import iconClock from "../../assets/feather/clock.svg";
import React, {useEffect, useState} from "react";
import {bulletinProvider} from "../../features/bulletin/bulletin.service";
import {useForceUpdate} from "../../services/misc.functions";
import {useAvailableHippodromes} from "../../features/bulletin/bulletin.store";
import {Storage} from "../../services/localstorege.service";
import {ApiService} from "../../lib/http.service";
import {env} from "../../constants/global.vars";
import {Ticket} from "./components/ticket";
import {isMobile} from "../../App";
import {useParams} from "react-router-dom";
import {tipstersData} from "../../store/misc.store";
import {Comments} from "../comments/comments";

const tabs = [
    {value: 0, label: "HAZIR KUPONLAR"},
    {value: 1, label: "YORUMLAR"},

];

export function Coupons(props: any) {
    const params = useParams();

    const forceUpdate = useForceUpdate();
    // Bülten güncellemesinde yeniden çizim artık anlık görüntüden geliyor.
    const hippodromes = useAvailableHippodromes();
    const [hippodrome, setHippodrome] = useState<any>(null);
    const [coupons, setCoupons] = useState<any>(null)
    const [tipsters, setTipsters] = useState<any>(null)
    const [selectedTipster, setSelectedTipster] = useState<any>(null)

    const [selectedTab, setSelectedTab] = useState<any>(params?.tab ? tabs[Number(params?.tab)] : tabs[0]);

    // Render sırasında çağrılamaz: `refreshAvailable*` artık anlık görüntü yayınlıyor ve yayın
    // bu bileşeni yeniden çizeceği için sonsuz döngü olurdu. Diğer bülten sayfalarındaki desen.
    useEffect(() => {
        bulletinProvider.refreshAvailableHippodromes();
    }, []);


    const handleSelect = (e: any) => {
        if (e.target.id) {
            setSelectedTab(tabs[e.target.id]);
        }
    };



    if (!hippodrome && hippodromes.length > 0) {
        if (params.tab != null) {
            let selectedHippodrome = hippodromes.filter((el: any) => {
                return el.keyword.toLowerCase() + el._id === params.tab?.toLowerCase();
            });
            if (selectedHippodrome.length > 0) {
                setHippodrome(selectedHippodrome[0])
            } else {
                setHippodrome(hippodromes[0]);
            }
        } else if (props.hippodrome) {
            setHippodrome(props.hippodrome)
        } else {
            setHippodrome(hippodromes[0]);
        }
    }


    useEffect(() => {
        if (hippodrome) {
            Storage.del(`tipsterCoupons-${hippodrome?.card_id}`);
            let cachedData = Storage.get(`tipsterCoupons-${hippodrome?.card_id}`);
            if (!cachedData) {
                setCoupons(false);
                let api = new ApiService()
                api.start('post', env.api + '/games/api/tjk/tipster-coupons', {card_id: hippodrome.card_id}, false)
                    .then((res: any) => {
                        Storage.set(`tipsterCoupons-${hippodrome.card_id}`, res.data, 1 * 60 * 1000)
                        if (res.data.error != null) {
                            setCoupons([]);
                        } else {
                            setCoupons(res.data)
                            let tipstersUniqeList: any = []
                            res.data.map((el: any) => {
                                if (tipstersUniqeList.indexOf(el.member_id.toString()) === -1) {
                                    tipstersUniqeList.push(el.member_id.toString());
                                }
                            })
                            setTipsters(tipstersUniqeList)
                        }


                    })
            } else {
                setCoupons(cachedData);
                let tipstersUniqeList: any = []
                cachedData.map((el: any) => {
                    if (tipstersUniqeList.indexOf(el.member_id.toString()) === -1) {
                        tipstersUniqeList.push(el.member_id.toString());
                    }
                })
                setTipsters(tipstersUniqeList)
            }
        }
    }, [hippodrome]);

    if (!hippodrome) {
        return <></>
    }

    return (<div className={"page-widget  container"}>


        {selectedTab.value === 0 && <>
            {!props.hippodrome && <div className="bettingtype-options p-3">
                <div className={"d-flex overflow-scroll align-items-center w-100"} style={{gap:"16px"}}>
                    {hippodromes.map((hipData: any, key: any) => {
                        return <div key={"ticket-hippodrome-" + key} className={`ticket-hippodrome ${hippodrome._id == hipData._id ? 'selected' : ''}`} onClick={() => {
                            setHippodrome(hipData);
                        }}>
                            {hipData.keyword}
                        </div>
                    })}

                </div>
               {/* <div className="row">

                    <div className={`col-12 col-lg-4`}>
                        {hippodrome ? <select value={hippodrome.keyword} onChange={(e: any) => {
                            setHippodrome(hippodromes.find((data: any) => data.keyword === e.target.value));
                            setSelectedTipster(null);
                        }}>
                            {hippodromes.map((data: any, key: any) => {
                                return (<option value={data.keyword}
                                                key={`available-hippodrome-${key}`}>{data.location}</option>)
                            })}
                        </select> : null}

                    </div>


                </div>*/}
            </div>}
            <div className="row">
                <div className="col">
                    <div className="page-widget">

                        <div className="">

                            {coupons == null && <>
                                <div className="row">
                                    {Array.from(Array(12).keys()).map((ticket, index) => {
                                        return (
                                            <div className="col-12 col-lg-4" key={`home-tickets-${index}`}>
                                                <div className="ticket-widget skeleton">
                                                    <div className="header">
                                                    </div>
                                                    <div className="body">
                                                    </div>
                                                    <div className="footer">
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>}


                            {coupons && coupons.length === 0 && <p className="p-4 text-center">
                                <img alt={"iconClock"} src={iconClock} width={64}/> <br/><br/>
                                Seçtiğiniz hipdromdaki koşular için henüz hazır kupon paylaşılmamış, <br/> Uzman
                                tahmincilerimiz sizler
                                için en kısa zamanda tahminlerini paylaşacaktır.</p>}


                            <div className="row">
                                {coupons && coupons.length > 0 && coupons.map((ticket: any, index: number) => {
                                    if (selectedTipster) {
                                        if (ticket.member_id.toString() === selectedTipster.toString()) {
                                            return (
                                                <div className="col-12 col-lg-4 mb-4" key={`home-tickets-${index}`}>
                                                    <Ticket ticket={ticket} hippodrome={hippodrome}/>
                                                </div>
                                            );
                                        }
                                    } else {
                                        return (
                                            <div className="col-12 col-lg-4 mb-4" key={`home-tickets-${index}`}>
                                                <Ticket ticket={ticket} hippodrome={hippodrome}/>
                                            </div>
                                        );
                                    }

                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>}


    </div>)
}
